import React from "react";
import TableRow from './TableRow';
import styles from "./TableStyle.module.css"
import chakra3 from "../image/Chakra3.png"
import {single_game_coordinates} from "./player_coordinates_calculator";
import ArrowsMap from "./ArrowsMap";

function Table(props) {

    function PlayerStyle() {
        const player_pos = props.currentUserCell

        const cellHeight = parseInt(props.fieldStyle.cell_height)
        const cellWidth = parseInt(props.fieldStyle.cell_width)
        const tablePaddingTop = parseInt(props.fieldStyle.padding_top)
        const tablePaddingleft = parseInt(props.fieldStyle.padding_left)

        const coords = single_game_coordinates(player_pos, cellWidth, cellHeight, tablePaddingTop, tablePaddingleft)

        return Object.assign(
            {
                display: "flex",
                backgroundImage: "url(" + chakra3 +")",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "local",
                backgroundPosition: "center",
                height: "50px",
                width: "50px",
                position: "absolute",
                transition: "all 2s linear",
                top: coords.top,
                left: coords.left,
                textAlign: "center",
                alignContent: "center",
                fontWeight: "bold",
                fontSize: "1.8em",
                zIndex:1001
            }

        )
    }

    function PlayerCharStyle() {
        return Object.assign(
            {
                maxWidth: "fit-content",
                maxHeight: "fit-content",
                margin: "auto"
            }
        )
    }

    return (
        <>
            <div id={"palyer"} style={new PlayerStyle()}>
                <div style={new PlayerCharStyle()}>{props.playerName.charAt(0)}</div>
            </div>
            <ArrowsMap
                fieldStyle={props.fieldStyle}
                steps={props.gameState.steps}
                gameFieldOffset={0}
            />
            <table className={styles.table}>
                <tbody style={{border: props.fieldStyle.table_border}}>
                {props.tbodyData.map((item) => {
                    return <TableRow key={item.row_id} data={item.items}
                                     currentUserCell={props.currentUserCell}
                                     cards={props?.cards}
                                     fieldStyle={props.fieldStyle}
                                     gameState={props.gameState}
                                     loginValid={props.loginValid}
                    />
                })}
                </tbody>
            </table>
        </>
    );
}

export default Table;